import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./RadioButtonList.module.css";

/**
 * Interactive component. Radio button list with an array of options as radio buttons.
 */
export function RadioButtonList({
  options,
  onClick,
  direction,
  customClassName,
  listName,
  selectedOption,
  readOnly = false
}) {
  return (
    <div
      className={classNames(
        styles.flex,
        direction === "horizontal"
          ? styles["horizontal-flex"]
          : styles["vertical-flex"]
      )}
    >
      {options.map((option) => (
        <div
          key={option}
          className={classNames(styles.flex, {
            [styles["horizontal-container"]]: direction === "horizontal",
            [styles["vertical-container"]]: direction === "vertical",
          })}
        >
          <input
            type="radio"
            disabled={readOnly}
            value={option}
            name={listName}
            onChange={() => onClick(option)}
            checked={selectedOption === option}
            className={classNames(styles["radio-button"], customClassName)}
          />
          <label htmlFor={option} className={classNames(styles.label)}>
            {option}
          </label>
        </div>
      ))}
    </div>
  );
}

RadioButtonList.propTypes = {
  /**
   * Array of options to display as radio buttons.
   */
  options: PropTypes.array,
  /**
   * Function that fires when the selected option changes.
   */
  onClick: PropTypes.func,
  /**
   * String that determines if the list is displayed vertically or horizontally.
   */
  direction: PropTypes.oneOf(["horizontal", "vertical"]),
  /**
   * String that includes an optional className to change the style of the individual radio buttons.
   */
  customClassName: PropTypes.string,
  /**
   * String that determines the list category.
   */
  listName: PropTypes.string,
  /**
   * String that determines the currently selected option.
   */
  selectedOption: PropTypes.string,
};

RadioButtonList.defaultProps = {
  /**
   * Defaults to avoid undefined.
   */
  options: [],
  /**
   * Defaults to no selected option.
   */
  selectedOption: "",
};
